<template>
  <v-container>
    <!-- logo -->
    <v-row>
      <v-img
        :src="require('../../../assets/logo.png')"
        :class="[$vuetify.breakpoint.mdAndUp ? 'my-4' : '']"
        contain
        :height="$vuetify.breakpoint.mdAndUp ? '200' : '140'"
      />
    </v-row>
    <!-- title -->
    <v-row>
      <v-col mb-4>
        <h1
          class="text-center font-weight-bold"
          :class="[$vuetify.breakpoint.mdAndUp ? 'display-2 mb-3' : 'display-1 mb-1']"
          :style="headingStyle"
        >
          <span v-if="routeName === 'login'">
            Velkommen til EPIAS
          </span>
          <span v-else>
            EPIAS
          </span>
          <span
            v-if="environment === 'DEVELOPMENT'"
            class="red--text"
          >
            DEV
          </span>
          <span
            v-else-if="environment === 'STAGING'"
            class="blue--text"
          >
            {{
              environment
            }}
          </span>
        </h1>
      </v-col>
    </v-row>
    <!-- subtitle -->
    <v-row
      v-if="routeName === 'login'"
      class="hidden-sm-and-down"
    >
      <v-col
        cols="10"
        alignment="center"
        justify="center"
        class="mx-auto py-0 mb-0"
        lg="7"
        xl="6"
      >
        <p class="subheading text-center font-weight-regular">
          En videnskabelig undersøgelse af effekten af psykomotorisk terapi i samarbejde mellem
          Psykomotoriske Terapeuter i København, Københavns Professionshøjskole og dig.
        </p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import sassVariablesJson from '@/styles/variables.json'
import { vxm } from '../../../state/index'

export default {
  name: 'PageHeader',
  data: () => ({
    environment: vxm.app.environment,
    headingStyle: `font-family: ${sassVariablesJson['my-heading-font-family']} !important;`,
  }),

  computed: {
    routeName() {
      return this.$route.name
    },
  },
}
</script>

<style></style>
